import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from "../../../../../services/etiquetado.service";

@Component({
    selector: 'app-marcas-etq-pais-denominacion',
    templateUrl: './marcas-etiquetador-pais-denominacion.component.html'
})
export class MarcasEtiquetadorPaisDenominacionComponent implements OnInit {

    public new = false;
    public editables;

    private _marcaId;
    private _paisId;
    private _denominacionId;
    private _etiquetadorId;

    public pais;
    public denominacion;
    public etiquetador;

    private _etiquetador;

    public allGrupoEtiquetasCaja;
    public allGrupoEtiquetasPallet;
    public marcasPaisDenominacion;

    public toCloseSpinner = 0;

    public etiquetadorMarcasPaisDenominacion;
    private _marcaPaisDenominacion;

    public marcasForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public deleteModal = false;

    @Input() paisId: number;
    @Input() denominacionId: number;
    @Input() etiquetadorId: number;

    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _spinnerService: SpinnerService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        const promises: Promise<any>[] = [];

        promises.push(this.getAllGruposEtiquetaCajas());
        promises.push(this.getAllGruposEtiquetaPallet());
        promises.push(this.getMarcas());
        Promise.all(promises).then(
            () => {
                this._paisId = this.paisId;
                this._denominacionId = this.denominacionId;
                this._etiquetadorId = this.etiquetadorId;
                this._etiquetador = {
                    etiquetadorId: this._etiquetadorId,
                    paisId: this._paisId,
                    denominacionId: this._denominacionId
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getEtiquetadorMarcaPaisDenominacion(this._etiquetador).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    this.etiquetadorMarcasPaisDenominacion = resp;
                });
                return true;
            }, (error) => {
                if (error.status === 420) {
                    this.pushMessage.emit('global.error.noAccess');
                } else {
                    this.pushMessage.emit('global.error.noResponse');
                }
            }
        ).catch(e => console.log(e));

        this.pais = this.paises.find(x => x.id === this.paisId);
        this.denominacion = this.denominaciones.find(x => x.id === this.denominacionId);
        this.etiquetador = this.etiquetadores.find(x => x.id === this.etiquetadorId);
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public get marcas() {
        return this._dataProvider.marcas;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get denominaciones() {
        return this._dataProvider.denominaciones;
    }

    public reload() {
        this._etiquetador = {
            etiquetadorId: this._etiquetadorId,
            paisId: this._paisId,
            denominacionId: this._denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getEtiquetadorMarcaPaisDenominacion(this._etiquetador).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.etiquetadorMarcasPaisDenominacion = resp;
        });
    }

    public getAllGruposEtiquetaCajas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 1
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasCaja = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasCaja.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getAllGruposEtiquetaPallet(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 2
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasPallet = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasPallet.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getMarcas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                paisId: this.paisId,
                denominacionId: this.denominacionId
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._etiquetadoService.getMarcas(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.marcasPaisDenominacion = resp.lista;
                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getGruposEtiqueta(etiquetador, number) {
        return etiquetador.gruposEtiquetaEtiquetadorMarcaPaisDenominacion.filter(x => x.tipoConfeccionId === number);
    }

    public close() {
        this.deleteModal = false;
        this.refresh.emit(false);
    }

    public closeDeleteModal() {
        this.deleteModal = false;
    }

    public toRefresh(value) {
        this.new = false;
        this.editables = '';
        if (value) {
            this.reload();
        }
    }

    public editableChanged(marcaPaisDenominacion) {
        this.editables = marcaPaisDenominacion;
        this.new = false;
    }

    public showMessages(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}